"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanySelect = void 0;
var React = require("react");
var react_select_1 = require("react-select");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var CompanySelect = function (_a) {
    var customStyles = _a.customStyles, selectedCustomer = _a.selectedCustomer, updateCustomer = _a.updateCustomer, fetchCustomers = _a.fetchCustomers, wizard = _a.wizard, fetchStatus = _a.fetchStatus;
    return (React.createElement("div", { className: "company-change-select" },
        React.createElement("label", { className: "modal-label", htmlFor: "companyName" }, (0, translation_1.getLocalization)('firstTimeLogin/step1/company')),
        React.createElement(react_select_1.default, { styles: customStyles, classNamePrefix: "react-select", id: 'companyName', placeholder: (0, translation_1.getLocalization)('admin/projectsTab/editProject/basicInformation/company/modal/placeholder'), menuPlacement: 'auto', value: [selectedCustomer], getOptionValue: function (_a) {
                var name = _a.name;
                return name;
            }, getOptionLabel: function (_a) {
                var name = _a.name;
                return name;
            }, onChange: function (customer) { return updateCustomer(customer); }, onInputChange: fetchCustomers, isSearchable: true, options: wizard.customers.status !== 'STANDBY'
                ? wizard.customers.customers
                : [] }),
        React.createElement("div", { className: "company-modal-error-message" }, fetchStatus.isFailure && (React.createElement("span", null, (0, translation_1.getLocalization)('change/company/failed')))),
        React.createElement("div", { className: "company-info-text-container" },
            React.createElement("p", null, (0, translation_1.getLocalization)('change/company/info/first')),
            React.createElement("p", null, (0, translation_1.getLocalization)('change/company/info/second')))));
};
exports.CompanySelect = CompanySelect;
